<template>
  <el-dialog title="配件选择" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
             style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height" style="display:flex">
          <!-- 左边------- 树型结构 -->
          <div class="left_tree">

            <div
              style="padding: 5px;margin: 2px 8px;border: 1px solid #ededed;">
              <div class="title">
                <svg t="1676961094129" class="icon tree_icon" viewBox="0 0 1024 1024"
                     version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2887" width="20" height="20">
                  <path
                    d="M384 725.333333c0 21.333333 17.066667 38.4 38.4 42.666667H640v-42.666667c0-21.333333 17.066667-38.4 38.4-42.666666H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666666v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666667h-213.333333c-68.266667 0-123.733333-51.2-128-119.466666V341.333333H170.666667c-21.333333 0-38.4-17.066667-42.666667-38.4V128c0-25.6 17.066667-42.666667 42.666667-42.666667h341.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666666H384v128h256v-42.666666c0-21.333333 17.066667-38.4 38.4-42.666667H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666666c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666666H384v170.666666z m426.666667 42.666667h-85.333334v85.333333h85.333334v-85.333333z m0-298.666667h-85.333334v85.333334h85.333334v-85.333334z m-341.333334-298.666666H213.333333v85.333333h256V170.666667z"
                    fill="#1296db" p-id="2888"></path>
                </svg>

                <span>商品分类</span>
              </div>
              <el-input placeholder="关键字过滤" v-model="filterText">
              </el-input>

              <el-tree class="tree-line" :data="data" lazy :load="loadChildNode" :props="defaultProps"
                       @node-click="handleNodeClick" :filter-node-method="filterNode" ref="tree" v-if="isRouterAlive">
              </el-tree>
            </div>
          </div>
          <div class="table_main" style="height: 400px!important;">
            <vxe-grid ref="table-m2" height="390"
                      class="is-pointer" v-bind="vxeOption"
                      @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle"
                      @checkbox-change="addDataTable"
                      @checkbox-all="checkAll"
                      @cell-dblclick="checkWithSubmit"
            >

              <template #form>

                <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                          :data="formData1" @submit="searchEvent" @reset="searchEvent">
                  <vxe-form-item title="考核名称:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.name" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="考核编码:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.code" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="考核类型:" field="name">
                    <template v-slot>
                      <el-select v-model="formData.checkType" style="width: 165px;" clearable >
                        <el-option label="处罚" :value=1 />
                        <el-option label="奖励" :value=2 />
                      </el-select>
                    </template>
                  </vxe-form-item>
                </vxe-form>
                <div class="clearfix screen-btns">
                  <div class="fr" style="display: inline-block;
    float: right;
    margin-top: -39px;">
                    <!-- <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"
                      status="primary" plain>重置</vxe-button> -->
                    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索
                    </vxe-button>
                  </div>
                </div>
              </template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>
    <label id="labBtn" class="transverse">
      <div class="icon">
        <i class="el-icon-more"></i>
        <i class="el-icon-more"></i>
      </div>
    </label>
    <div class="multipleChoice">
      <el-tooltip :enterable="false" effect="dark" content="全部删除" placement="top">
        <a class="allDel icon-quanbushanchu" @click="clearChecked()"></a>
      </el-tooltip>
      <div class="list">
        <div class="item" v-for="(checkRow, index) in checkRows" :key="checkRow.id">
          <p>{{ checkRow.name }}</p>
          <a class="el-icon-close" @click="clearTable1Select(index)"></a>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">

			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="dialogPrimary" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'

import {fetchTree} from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import request from "@/router/axios";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'itemId', 'replacePartsObj'],
  mixins: [selectDialogMixins],
  components: {pager},

  created() {
    this.initSetting();
    if (this.itemId) {
      this.formData.itemId = this.itemId
    } else {
      this.type = 1
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      type: 0,
      getTableDataUrl: '/basic/basParts/getItemNotBindPartsListPage',
      total: 0,
      filterText: '',
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        checkType: null,
        useWhere: null,
        usable: 1,
        parentId: 0,
        size: 0,
        current: 1,
        name : null,
        code : null
      },
      formData1: {
        partsCode: '',  // 编码,同厂商下惟一
        partsName: '',  // 名称
        partsSpec: '',  // 型号
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchItemName: '',
      searchItemCode: '',
      searchBrandName: '',
      selectedRow: {
        id: '', name: ''
      },
      checkedArray: [],
      columns: [
        {type: "checkbox", width: 30, title: '', resizable: false, fixed: 'left'},
        { title: '考核名称', field: 'name', treeNode: true, width: 110 },
        { title: '考核编码', field: 'code', width: 110, },
        { field: 'checkType', title: '考核类型', width: 120,
          slots: {
            default: ({row}) => {
              if (row.checkType == 1) {
                return [
                  <div class="txt-status disable">
                    <span>处罚</span>
                  </div>
                ];
              } else if (row.checkType == 2) {
                return [
                  <div class="txt-status">
                    <span>奖励</span>
                  </div>
                ];
              }
            }
          }
        },
        { field: 'createTime', title: '创建时间', width: 200 },
        { title: '创建人', field: 'createBy', width: 110, },
      ]
    };
  },


  methods: {
    flushed() {
      this.checkedArray = []
      this.$refs['table-m2'].commitProxy('reload');
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 搜索
    searchEvent() {
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },
    // // 保持
    //   saveDialog(){
    //     const  $grid = this.$refs.table;
    //     console.log($grid,"选中的值");
    //     const rows = $grid.getCheckboxReserveRecords(true);
    //     $grid.clearCheckboxRow();
    //     console.log(rows,"选中的值");
    //     console.log("点击确认！！")
    //     this.$emit("confirm", rows.map(item => item.id),this.itemId);
    //     // this.showDialog = false;
    //   },

    // 重置
    resetEvent() {
      this.formData.searchCount = false
      this.formData.current = 1
      this.formData.partsCode = ''
      this.formData.partsName = ''
      this.formData.partsSpec = ''
      this.formData.bigCategoryId = ''
      this.formData.smallCategoryId = ''
      console.log('request', this.requestParam)
      this.formData1 = {
        partsCode: '',  // 编码,同厂商下惟一
        partsName: '',  // 名称
        partsSpec: '',  // 型号
      }
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
      this.reloadTree()
    },


    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },


    reloadTree() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },

    // 点击的树形 点
    handleNodeClick(node, data) {
      let id = data.data.id;
      this.formData.parentId = id;
      this.initTableList();
      this.flushed()
    },

    initTableList() {
      let tableOption = {}
      if (this.type === 1) {
        /*let idList = this.replacePartsObj.basPartsReplaceIdList
        let dataId = this.replacePartsObj.dataId
        if (idList == null || idList.length === 0) {
          if (dataId) {
            this.formData.excludePartsIds = []
            this.formData.excludePartsIds.push(dataId)
          } else
            this.formData.excludePartsIds = null
        } else {
          let temp = []
          idList.forEach(item => {
            temp.push(item)
          })
          this.formData.excludePartsIds = temp
          if (dataId) {
            this.formData.excludePartsIds.push(dataId)
          }
        }*/
        tableOption = {
          vue: this,
          tableRef: 'table-m2',
          tableName: 'basic_fault_code_list-m1',
          path: api.basCheckSubject.getPageDataUrl,
          param: this.formData,
          method: 'post',
          columns: this.columns
        }
      } else {
        tableOption = {
          vue: this,
          tableRef: 'table-m1',
          tableName: 'basic_fault_code_list-m1',
          path: api.basCheckSubject.getPageDataUrl,
          param: this.formData,
          method: 'post',
          columns: this.columns
        };
      }
      console.log("this.vxeOption1",this.vxeOption)
      this.vxeOption = initVxeTable(tableOption)
      console.log("this.vxeOption2",this.vxeOption)
      this.flushed()
    },


    // 加载页面
    loadChildNode(node, resolve) {
      request({
        url:api.basCheckSubject.getTreeData,
        method: 'post',
        data: {
          parentId: node.data.id === null || node.data.id === undefined ? 0 : node.data.id
        }
      }).then(({data}) => {
        resolve(
          data.data.map(item => {
            return {
              label: item.name,
              id: item.id,
              leaf: !item.hasChild,
            }
          })
        )
      });
    },

  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep body .dialog-style.list-dialog .el-dialog__body {
  background: #F1F5FB;
  padding: 8px 0px 1px !important;
  height: 575px;
}

// ::v-deep .grid-height {
// 	height: calc(100vh - 270px) !important;
// }
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -40px !important;
  position: absolute !important;
  z-index: 9;
  background-color: #ffffff;
}

body .dialog-style.list-dialog .el-dialog__body .multipleChoice {

  z-index: 99999;
}
</style>
